import { DateTime, DateTimeFormatOptions } from 'luxon'

export const formatDate = (date: string, formatOptions?: DateTimeFormatOptions) => {
    const dateN = DateTime.fromISO(date)
    const _formatOptions = formatOptions ?? { weekday: 'long', month: 'long', day: '2-digit', hour: '2-digit', minute: '2-digit' }
    return dateN.toLocaleString(_formatOptions)
}
